// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__52a18","default":"Loader_default__8af82","spin":"Loader_spin__01021","light":"Loader_light__94028","inline":"Loader_inline__037d6"};